import { useTranslation } from 'next-i18next/pages'

import type { ImageProps } from '../../../types/ui'
import { Typography } from '../../Typography'

import { type AttributeProgress, Attribute } from './Attribute/Attribute'
import { DoubleArrowIcon } from './DoubleArrowIcon'
import {
  StyledArrowWrapper,
  StyledAttributesColumn,
  StyledAttributesWrapper,
  StyledBodyImage,
  StyledGoalImages,
  StyledHeader,
  StyledWrapper,
} from './VisualGoalComparison.Styled'

type Comparison = {
  image: ImageProps
  bodyFat: string
  fitnessLevel: string
  fitnessLevelProgress: AttributeProgress
}

export type VisualGoalComparisonProps = {
  fitnessLevelTitle: string
  now: Comparison
  goal: Comparison
}

export const VisualGoalComparison = ({
  fitnessLevelTitle,
  goal,
  now,
}: VisualGoalComparisonProps) => {
  const { t } = useTranslation()

  return (
    <StyledWrapper>
      <StyledHeader>
        <Typography $variant="Poppins/T2 - Medium">
          {t('paywall_now')}
        </Typography>
        <Typography $variant="Poppins/T2 - Medium">
          {t('paywall_goal')}
        </Typography>
      </StyledHeader>
      <StyledGoalImages>
        <StyledBodyImage {...now.image} alt={'Body now'} />
        <StyledArrowWrapper>
          <DoubleArrowIcon />
        </StyledArrowWrapper>
        <StyledBodyImage {...goal.image} alt={'Goal body'} />
      </StyledGoalImages>
      <StyledAttributesWrapper>
        <StyledAttributesColumn>
          <Attribute label={t('paywall_body_fat')} value={now.bodyFat} />
          <Attribute
            label={fitnessLevelTitle}
            value={now.fitnessLevel}
            progress={now.fitnessLevelProgress}
          />
        </StyledAttributesColumn>
        <StyledAttributesColumn>
          <Attribute label={t('paywall_body_fat')} value={goal.bodyFat} />
          <Attribute
            label={fitnessLevelTitle}
            value={goal.fitnessLevel}
            progress={goal.fitnessLevelProgress}
          />
        </StyledAttributesColumn>
      </StyledAttributesWrapper>
    </StyledWrapper>
  )
}
